import { Link } from 'react-router-dom';
import { buttonClassName } from '@safetyhub/ui';
import { usePermissions } from '../../hooks/usePermissions';
import { AGENCY_LINK_CONNECT_PATH, AGENCY_LINK_REQUESTS_PATH } from '../../lib/agencySiteLinkView';

/**
 * 현장 목록 헤더의 대행 연결 입구 — 권한만 본다(플래그 `agency-site-link`와 그 진입 게이트는 2026-11-01에 걷었다).
 * - 「대행 현장 연결」: 연결 API가 요구하는 `site.manage`
 * - 「연결 요청」: 업체 쪽 승인은 OWNER · 기관 쪽 취소는 `site.manage`라 둘 중 하나면 보인다
 */
export default function AgencySiteLinkEntry({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const { canManageSites, isOwner } = usePermissions();
  if (!canManageSites && !isOwner) return null;
  return (
    <>
      <Link to={AGENCY_LINK_REQUESTS_PATH} className={buttonClassName('secondary', size)}>
        연결 요청
      </Link>
      {canManageSites && (
        <Link to={AGENCY_LINK_CONNECT_PATH} className={buttonClassName('secondary', size)}>
          대행 현장 연결
        </Link>
      )}
    </>
  );
}
